var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline"}},[_c('v-btn',{staticStyle:{"margin-left":"0","margin-right":"0"},attrs:{"flat":"","block":_vm.$vuetify.breakpoint.xsOnly,"color":"error"},on:{"click":function($event){return _vm.removeJob(_vm.jobId)}}},[_vm._v("delete")]),_c('confirm',{ref:"confirm"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }